// extracted by mini-css-extract-plugin
module.exports = {"main-component":"infoIcon_main-component__3o-xg"};